import { render } from "./CreateVolume.vue?vue&type=template&id=a726a9d8&scoped=true"
import script from "./CreateVolume.vue?vue&type=script&lang=js"
export * from "./CreateVolume.vue?vue&type=script&lang=js"

import "./CreateVolume.vue?vue&type=style&index=0&id=a726a9d8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a726a9d8"]])

export default __exports__